// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__3Chjk","header":"sidebar_header__raKhS","content":"sidebar_content__3LTvg","tag":"sidebar_tag__1jp5r"};